import '~/features/ShopLoginButton/ShopLoginButton';

import {defineInitFunction} from '~/utils/defineInitFunction';

import {initCustomerAccounts} from './initCustomerAccounts';

(() => defineInitFunction('initCustomerAccounts', initCustomerAccounts))();
